module.exports = __webpack_public_path__ + "static/media/17230023-jvh1wSgs.81d25374.JPG";